import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=1ea25d22&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=1ea25d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea25d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea25d22')) {
      api.createRecord('1ea25d22', component.options)
    } else {
      api.reload('1ea25d22', component.options)
    }
    module.hot.accept("./PlanCard.vue?vue&type=template&id=1ea25d22&scoped=true&", function () {
      api.rerender('1ea25d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/PlanCard.vue"
export default component.exports